import React from 'react';
import { RotationCargoOperation } from 'src/types/ViewModel/Stowage/Rotation/RotationCargoOperation';
import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';
import { ColumnConfig } from 'src/components/stowage/operationListView/utils/columnConfig';
import { ColumnWidths } from 'src/types/ViewModel/Stowage/ColumnWidths';
import OperationDataColumn from './OperationDataColumn';
import { getWarningClass } from 'src/utils/stowage/stowageOperation/operationFormatUtils';
import { getShipFigureCssClass } from 'src/utils/stowage/stowageOperation/operationDisplayUtil';

interface OperationColumnsContainerProps {
    orderedColumns: ColumnConfig[];
    cargoOperation: RotationCargoOperation;
    activeStowagePlan: StowagePlan;
    operationListColumnWidths: ColumnWidths;
}

/**
 * Container component that renders all data columns for an operation list item.
 * Maps over column configuration and delegates rendering to OperationDataColumn.
 */
const OperationColumnsContainer: React.FC<OperationColumnsContainerProps> = ({
    orderedColumns,
    cargoOperation,
    activeStowagePlan,
    operationListColumnWidths,
}) => {
    // Filter out the status icon column (handled separately)
    const contentColumns = orderedColumns.filter((col) => col.id !== 'statusIcon');

    return (
        <>
            {contentColumns.map((column) => {
                // Get column width from saved widths or default
                const width = operationListColumnWidths[column.id] || column.defaultFlex;

                // Determine warning class for certain columns
                const warningClass =
                    column.id === 'notStowedWeight' || column.id === 'notStowedVolume' ? getWarningClass(activeStowagePlan, cargoOperation) : '';

                // Determine special class for ship figure
                const specialClass =
                    column.id === 'shipFigure' || column.id === 'shipFigure2' ? getShipFigureCssClass(activeStowagePlan, cargoOperation) : '';

                return (
                    <OperationDataColumn
                        key={column.id}
                        column={column}
                        cargoOperation={cargoOperation}
                        activeStowagePlan={activeStowagePlan}
                        columnWidth={width}
                        warningClass={warningClass}
                        specialClass={specialClass}
                    />
                );
            })}
        </>
    );
};

export default OperationColumnsContainer;
